import React, {Component} from 'react';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import {splitNumber} from '../../../utils/utility'
import { Link } from 'react-router-dom';

const styles={
	tableHeaderStyle: {
		border: 'none',
		background: '#F5F5F5 '
	},
	tableHeaderColumn: {
		height: '35px',
		color: 'black',
		cursor: 'pointer',
		fontWeight: 'bolder',
		paddingLeft: '10px',
		position:'relative',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis'
	},
	tableTd: {
		paddingLeft: '10px',
		height: '30px',
		borderBottom: '1px solid black',
		whiteSpace:'nowrap',
		overflow:'hidden',
		textOverflow:'ellipsis'
	},
}
class AggregatedTable extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeIndex: props.activeIndex,
      arrowActive: 'down',
      data:props.data
    }
  }

  componentWillReceiveProps(nextProps) {
		if (!isEqual(nextProps.data.slice().sort(), this.props.data.slice().sort())) {
			this.setState({
				data: nextProps.data
      })
		}
	}
	
	showChannel(channel) {
		const {emailDeployments, socialDeployments, displayDeployments} = this.props.parentCampaignDetail;
		switch(channel) {
			case "email":
				return emailDeployments && emailDeployments.length > 0;
			case "social":
				return socialDeployments && socialDeployments.length > 0;
			case "display":
				return displayDeployments && displayDeployments.length > 0;
			default: 
				return false;
		}
	}

  render () {
		const {data} = this.props;
		const emailCount = find(data, {channel:"Email"});
		const socialCount = find(data, {channel:"Social"});
		const displayCount = find(data, {channel:"Display"});
		const totalCount = find(data, {channel:"total"});

    return (
      <div className="spread-table pl-20 mt-20">
				<table style={{ width: '100%' }}>
					<thead style={styles.tableHeaderStyle}>
						<tr style={{ height: '42px' }}>
							<th style={{width:'23%', ...styles.tableHeaderColumn}}>Activity</th>
							<th style={{width:'21%', ...styles.tableHeaderColumn}}>{(this.showChannel("email") && emailCount) && <Link className="agg-title-link" to={`/campaigns/report/${this.props.campaignId}/email/aggregated`}>Email</Link>}</th>
							<th style={{width:'21%', ...styles.tableHeaderColumn}}>{(this.showChannel("social") && socialCount) && <Link className="agg-title-link" to={`/campaigns/report/${this.props.campaignId}/social/aggregated`}>Social</Link>}</th>
							<th style={{width:'21%', ...styles.tableHeaderColumn}}>{(this.showChannel("display") && displayCount) && <Link className="agg-title-link" to={`/campaigns/report/${this.props.campaignId}/display/aggregated`}>Display</Link>}</th>
							<th style={{width:'13%', paddingRight:'20px', textAlign:"right", ...styles.tableHeaderColumn}}>Total</th>
						</tr>
					</thead>
					<tbody>
						<tr style={{height: '42px'}}>
							<td><strong>Messages</strong></td>
							<td>{(this.showChannel("email") && emailCount) && splitNumber(emailCount.messages)()}</td>
							<td>{(this.showChannel("social") && socialCount) && splitNumber(socialCount.messages)()}</td>
							<td>{(this.showChannel("display") && displayCount) && splitNumber(displayCount.messages)()}</td>
							<td style={{textAlign:"right"}}>{(totalCount && totalCount.messages) && splitNumber(totalCount.messages)()}</td>
						</tr>
						<tr style={{height:"42px"}}>
							<td><strong>Engagement</strong></td>
							<td>{(this.showChannel("email") && emailCount) && splitNumber(emailCount.engagement)()}</td>
							<td>{(this.showChannel("social") && socialCount) && splitNumber(socialCount.engagement)()}</td>
							<td>{(this.showChannel("display") && displayCount) && splitNumber(displayCount.engagement)()}</td>
							<td style={{textAlign:"right"}}>{(totalCount && totalCount.engagement) && splitNumber(totalCount.engagement)()}</td>
						</tr>
					</tbody>
				</table>
      </div>
    )
  }
}

AggregatedTable.propTypes = {
	data: React.PropTypes.array.isRequired,
	campaignId: React.PropTypes.string.isRequired,
	parentCampaignDetail: React.PropTypes.object.isRequired,
}

AggregatedTable.defaultProps = {
	data: [],
	parentCampaignDetail: {},
	campaignId: 0
}

export default AggregatedTable;



// WEBPACK FOOTER //
// ./src/components/Campaigns/Report/AggregatedTable.jsx